import React from "react";
import { FileText } from "lucide-react";
import { toast } from "react-toastify";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useArticles, useRemoveArticle } from "../hooks";
import { useMe } from "../../users/hooks/useMe";
import { UserRole } from "../../../__generated__/globalTypes";
import { articleTypeLabel } from "../../../helpers/enum-labels";

interface IProps {
  customerId?: number;
}

export const ArticlesList: React.FC<IProps> = ({ customerId }) => {
  const { data, loading, refetch } = useArticles({ where: { customerId } });
  const { data: meData } = useMe();
  const [remove] = useRemoveArticle();

  const isAdmin = meData?.me?.role === UserRole.Admin;

  const handleRemove = async (id: number) => {
    if (!window.confirm("Supprimer cet article ? Cette action est irréversible.")) return;
    try {
      const { data } = await remove({ variables: { id } });
      if (data?.removeArticle?.ok) {
        toast.success("L'article a été supprimé");
        refetch();
      } else {
        toast.error(data?.removeArticle?.error ?? "Une erreur est survenue");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  if (loading) return <Loading />;

  if (!data?.articles?.results?.length) {
    return <EmptyList text="Aucun article" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Titre</TableCell>
          <TableCell header>Type</TableCell>
          <TableCell header>Site</TableCell>
          {!customerId && <TableCell header>Client</TableCell>}
          {isAdmin && <TableCell header align="center">Actions</TableCell>}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.articles?.results?.map((article) => (
          <TableRow key={`article-${article.id}`} hover={false}>
            <TableCell>
              <span className="inline-flex items-center gap-1.5">
                <FileText className="w-4 h-4 text-gray-500" />
                {article.title}
              </span>
            </TableCell>
            <TableCell>{articleTypeLabel(article.type)}</TableCell>
            <TableCell>{article.site}</TableCell>
            {!customerId && <TableCell>{article.customer?.name ?? "-"}</TableCell>}
            {isAdmin && (
              <TableCell align="center">
                <span
                  className="text-red-600 text-sm cursor-pointer hover:underline"
                  onClick={() => handleRemove(article.id)}
                >
                  Supprimer
                </span>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
